'use client';

import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  Image,
  ImageToolbar,
  ImageUpload,
  ImageResize,
  ImageStyle,
  FontBackgroundColor,
  FontColor,
  FontSize,
  FontFamily,
  Alignment,
  Link,
  List,
  Table,
  TableToolbar,
  BlockQuote,
  Heading,
  ImageCaption,
  WordCount,
  Indent,
  IndentBlock,
} from 'ckeditor5';
import { useDispatch } from 'react-redux';
// import helperServices from '@/features/helper/helper_services';
import { toast } from 'react-toastify';
import { LineHeight } from '@rickx/ckeditor5-line-height';
import lineHeightTranslations from '@rickx/ckeditor5-line-height/translations/zh-cn.js';

const CKEditorComponent = ({ setEditorContent, setEditorWordCount, data }) => {
  const dispatch = useDispatch();

  // function getbase64(file: any) {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();

  //     reader.onload = () => {
  //       resolve(reader.result);
  //     };

  //     reader.onerror = reject;

  //     reader.readAsDataURL(file);
  //   });
  // }

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        // resolve(reader.result);
        const base64Data = reader.result;

        // Report initial progress (e.g., 20% for Base64 conversion)

        // Upload the Base64 data to the backend
        // helperServices
        //   .uploadImage({ file: base64Data })
        //   .then((response) => {
        //     // Backend response received

        //     const secureUrl = response?.data?.secure_url;

        //     if (secureUrl) {
        //       resolve({ default: secureUrl });
        //     } else {
        //       reject(new Error('Image upload failed: No URL returned.'));
        //     }
        //   })
        //   .catch((error) => {
        //     reject(error);
        //   });
      };
      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  }

  function createBase64UploadAdapter(loader) {
    // Report progress
    let reportProgress = (uploaded, total) => {
      loader.uploadTotal = total;
      loader.uploaded = Math.min(uploaded, total);
    };
    return {
      upload() {
        return loader.file.then(
          (file) =>
            new Promise((resolve, reject) => {
              const total = file.size; // Total file size
              let progress = 0;

              reportProgress(Math.floor(total * 0), total);

              console.log(loader, 'version');

              console.log(reportProgress, 'season of work');

              // Initialize FileReader for Base64 conversion
              const reader = new FileReader();

              // FileReader onload event
              reader.onload = () => {
                const base64Data = reader.result;

                // Report initial progress (e.g., 20% for Base64 conversion)
                reportProgress(Math.floor(total * 0.2), total);

                // Upload the Base64 data to the backend
                // helperServices
                //   .uploadImage({ file: base64Data })
                //   .then((response) => {
                //     // Backend response received
                //     reportProgress(total, total); // Report 100% progress

                //     const secureUrl = response?.data?.secure_url;

                //     if (secureUrl) {
                //       resolve({ default: secureUrl });
                //     } else {
                //       reject(
                //         new Error("Image upload failed: No URL returned.")
                //       );
                //     }
                //   })
                //   .catch((error) => {
                //     reject(error);
                //   });

                // helperServices
                //   .uploadImage({ file: base64Data })
                //   .then((res) => {
                //     toast('successfully');
                //     resolve({
                //       default: res?.data?.secure_url,
                //     });
                //   })
                //   .catch((err) => {
                //     reject(err);
                //   });
              };

              // FileReader onerror event
              reader.onerror = (error) => {
                reject(error);
              };

              // Start reading the file as Base64
              reader.readAsDataURL(file);
            })
        );
      },

      abort() {
        // Handle abort if needed
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return createBase64UploadAdapter(loader);
    };
  }

  return (
    <div className="w-full">
      <CKEditor
        editor={ClassicEditor}
        data={data}
        config={{
          extraPlugins: [uploadPlugin],
          toolbar: {
            items: [
              'undo',
              'redo',
              '|',
              'heading',
              '|',
              'bold',
              'italic',
              'link',
              '|',
              'bulletedList',
              'numberedList',
              '|',
              'outdent', // Button for reducing indent
              'indent',
              'lineHeight',
              '|',
              'fontFamily',
              'fontSize',
              'fontColor',
              '|',
              'alignment:left',
              'alignment:center',
              'alignment:right',
              'alignment:justify',
              '|',
              'insertImage',
              '|',
              'imageStyle:alignLeft',
              'imageStyle:alignRight',
              'imageStyle:full',
              '|',
              'insertTable',
              '|',
              'blockQuote',
              '|',
              'removeFormat',
            ],
          },
          fontFamily: {
            supportAllValues: true,
          },
          wordCount: {
            onUpdate: (stats) => {
              // console.log(`Words: ${stats.words}`);
              // console.log(`Characters: ${stats.characters}`);
              setEditorWordCount(Number(stats.words));
            },
          },
          fontSize: {
            options: [10, 12, 14, 'default', 18, 20, 22, 24],
            supportAllValues: true,
          },
          plugins: [
            Bold,
            Essentials,
            Italic,
            Mention,
            Paragraph,
            Undo,
            Image,
            ImageToolbar,
            ImageUpload,
            ImageResize,
            // Base64UploadAdapter, // Use this for Base64 uploads
            ImageStyle,
            FontBackgroundColor,
            FontColor,
            FontSize,
            Alignment,
            Link,
            List,
            Table,
            TableToolbar,
            BlockQuote,
            Heading,
            ImageCaption,
            WordCount,
            FontFamily,
            Indent,
            IndentBlock,
            LineHeight,
            // WordCountConfig,
            // WordCountUpdateEvent
          ],
          list: {
            properties: {
              styles: true,
              startIndex: true,
              reversed: true,
            },
          },
          lineHeight: {
            options: [
              'default',
              '10px',
              1,
              1.1,
              1.2,
              1.3,
              1.4,
              1.5,
              1.6,
              2,
              2.5,
              2.8,
              3.0,
              3.5,
              3.8,
              4.0,
              '150%',
              '8em',
              {
                title: 'Custom Title',
                model: '48px',
              },
            ],
          },
          simpleUpload: {
            uploadUrl:
              'https://moduverse-backend.onrender.com/api/v1/upload_through_cloudinary', // Backend endpoint for uploads
            withCredentials: true,
            headers: {
              Authorization: 'Bearer <YOUR_AUTH_TOKEN>', // Optional: Add authorization headers
            },
          },
          licenseKey: '<YOUR_LICENSE_KEY>',
          image: {
            toolbar: [
              'imageStyle:full',
              'imageStyle:alignLeft',
              'imageStyle:alignCenter',
              'imageStyle:alignRight',
              '|',
              'toggleImageCaption',
              'imageTextAlternative',
            ],
            styles: {
              options: [
                'full', // Center-align (default)
                'alignLeft', // Left-align the image
                'alignRight',
              ], // Right-align the image]
            },

            // upload: {
            //   type: 'base64',
            // },
            upload: {
              types: ['jpeg', 'png', 'gif', 'bmp', 'jpg', 'webp', 'tiff'],
              // uploadUrl:
              //   'https://api.cloudinary.com/v1_1/YOUR_CLOUD_NAME/image/upload',
              // headers: {
              //   Authorization: 'Bearer <YOUR_AUTH_TOKEN>',
              // },
            },
          },
        }}
        // onReady={(editor) => {
        //   // Modify Enter behavior programmatically
        //   editor.commands.get("enter")!.execute = () => {
        //     editor.execute("insertText", { text: "\n" }); // Insert line break instead of paragraph
        //   };
        // }}
        onChange={(event, editor) => {
          const data = editor.getData(); // Get the editor content
          setEditorContent(data); // Update state with the content

          // const uploads = editor.plugins
          //   .get('FileRepository')
          //   ._loaders.map((loader) => loader.responseData); // Uploaded objects

          // console.log('Uploaded Files:', uploads);
        }}
      />
    </div>
  );
};

export default CKEditorComponent;
